import { useMutation } from 'react-query'
// utils
import { getTransactions } from 'utils/requests'
// helpers
import get from 'lodash/get'

const useGetTransaction = () => {
  const { mutate, isLoading, isError, data } = useMutation({
    mutationFn: getTransactions,
    mutationKey: 'getTransactions'
  })

  return {
    mutate,
    isLoading,
    isError,
    records: get(data, 'data', [])
  }
}

export default useGetTransaction
